const TIMELINE_STOP_NUMBER_SETTING_LOCAL_STORAGE_KEY = 'timelineStopNumberPreference';

const getTimelineStopNumberPreference = (): boolean => {
  try {
    const preferenceJson = localStorage.getItem(TIMELINE_STOP_NUMBER_SETTING_LOCAL_STORAGE_KEY);
    return preferenceJson ? !!JSON.parse(preferenceJson) : false;
  } catch {
    return false;
  }
};

const setTimelineStopNumberPreference = (numbersVisible: boolean) => {
  try {
    localStorage.setItem(TIMELINE_STOP_NUMBER_SETTING_LOCAL_STORAGE_KEY, JSON.stringify(numbersVisible));
  } catch {
    // Persisting the preference is best-effort; ignore storage failures
    // (e.g. private mode / quota exceeded) so the toggle still works.
  }
};

export {
  getTimelineStopNumberPreference,
  setTimelineStopNumberPreference,
  TIMELINE_STOP_NUMBER_SETTING_LOCAL_STORAGE_KEY,
};
